import { useEffect, useState, useRef } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import Close from '@/icons/bwi/close.svg'
import ContactSupportForm from '@/components/forms/contact-support'
import CtaLink from '@/components/ui/cta-link'
import { cx } from '@/utils/strings'
import { useTranslations } from '@/utils/locale'
import { buttonStyles } from '../ui/cta-link'

function BorderPulse({ isActive = false, delay = 0 }) {
  return (
    <motion.div
      className={cx(
        `absolute top-0 left-0 z-1 w-full h-full rounded-lg pointer-events-none border-2 border-accent-teal/50`
      )}
      initial="hidden"
      animate={isActive ? 'visible' : 'hidden'}
      variants={{
        hidden: { opacity: 0 },
        visible: {
          scaleX: [1, 1.05, 1.1],
          scaleY: [1, 1.03, 1.07],
          opacity: [0, 1, 0],
        },
      }}
      transition={{ duration: 1.5, ease: 'linear', repeat: 2, delay }}
    />
  )
}

export default function HelpContactForm({
  isButtonStyle,
  inHelpDrawer,
}: {
  isButtonStyle?: boolean
  inHelpDrawer?: boolean
}) {
  const { t } = useTranslations()
  const [helpContactFormOpen, setHelpContactFormOpen] = useState(false)
  const supportRef = useRef(null)
  const [flash, setFlash] = useState(0)
  const hash = typeof window !== 'undefined' ? window.location.hash : ''

  useEffect(() => {
    if (hash === '#contact-support') {
      setHelpContactFormOpen(true)
      setFlash(1)
    }
  }, [hash])
  return (
    <div className={cx('relative', inHelpDrawer && 'flex items-end justify-end mr-5')}>
      <CtaLink
        asButton
        className={cx(
          !isButtonStyle && !inHelpDrawer && 'text-sm font-bold text-primaryBlue',
          inHelpDrawer &&
            '[&_span.font-bwi]:ml-2 [&_span.font-bwi]:mr-0 [&>span]:items-end [&>span]:flex-row-reverse hover:text-white'
        )}
        style={isButtonStyle ? buttonStyles.btnOutlined : buttonStyles.btnText}
        onClick={() => setHelpContactFormOpen(!helpContactFormOpen)}
        size="Smaller"
      >
        <span className="font-bwi mr-2">&#xe990;</span>
        {t('Contact support')}
      </CtaLink>

      <AnimatePresence>
        {helpContactFormOpen && (
          <motion.div
            ref={supportRef}
            key={`contact-support-${flash}`}
            className={cx(
              'absolute z-10 right-0 top-0 h-0 opacity-0 ',
              inHelpDrawer ? '-right-2 left-3 w[300px]' : 'w-[400px] md:w-[500px]'
            )}
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={{
              hidden: { height: 0, opacity: 0 },
              visible: { height: 'auto', opacity: 1 },
            }}
          >
            <BorderPulse isActive={flash === 1} />
            <BorderPulse isActive={flash === 1} delay={0.5} />
            <button
              className="float-right h-8 w-8 mr-8 mt-8 p-2 rounded hover:bg-gray-200 dark:hover:bg-gray-700"
              type="button"
              onClick={() => setHelpContactFormOpen(false)}
            >
              <Close className="text-indigoBlue dark:text-secondary-50" />
            </button>
            <div className="dark:text-secondary-50">
              <ContactSupportForm className="plausible-event-name=form+submit plausible-event-form=contact+support+sidebar" />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
